import { Headline } from '@vkontakte/vkui';
import React, { memo } from 'react';
import { aiPhotoGenerationStyles } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';
import type { AiPhotoGenerationImageStyleType } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

import styles from './AiPhotoGenerationStylesPopup.css';

interface IProps {
    onClick: (style: AiPhotoGenerationImageStyleType) => void;
}

export const AiPhotoGenerationStylesGrid = memo<IProps>(({ onClick }) => {
    return (
        <div className={styles.grid}>
            {aiPhotoGenerationStyles.map((style) => (
                <div key={style.key} className={styles.card} onClick={() => onClick(style.key)}>
                    <img src={style.image_url} alt={style.name} className={styles.image} draggable={false} />
                    <div className={styles.overlay} />
                    <Headline weight="2" className={styles.headline}>
                        {style.name}
                    </Headline>
                </div>
            ))}
        </div>
    );
});

AiPhotoGenerationStylesGrid.displayName = 'AiPhotoGenerationStylesGrid';
